/**
 * Local Wikipedia-style lore article: League of Shadows (faction).
 * Placeholder until full article text is authored.
 */
import { createComingSoonArticle } from './createComingSoonArticle';

const leagueOfShadowsArticle = createComingSoonArticle({
  title: 'League of Shadows',
  image: '/factions/league.png',
});

export default leagueOfShadowsArticle;
